(() => {
  const doc = document;
  const body = doc.body;
  const scrim = doc.querySelector('[data-site-scrim]');
  const mobileMenu = doc.querySelector('[data-mobile-menu]');
  const menuToggle = doc.querySelector('[data-menu-toggle]');
  const menuClose = doc.querySelector('[data-menu-close]');
  const filters = doc.querySelector('[data-collection-filters]');
  const filterToggle = doc.querySelector('[data-filter-toggle]');
  const filterClose = doc.querySelector('[data-filter-close]');
  let lastFocused = null;

  const setScrim = (visible) => {
    if (!scrim) return;
    scrim.hidden = !visible;
    requestAnimationFrame(() => scrim.classList.toggle('is-visible', visible));
  };

  const openMenu = () => {
    if (!mobileMenu || !menuToggle) return;
    lastFocused = doc.activeElement;
    mobileMenu.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    menuToggle.setAttribute('aria-expanded', 'true');
    body.classList.add('menu-open');
    setScrim(true);
    const focusTarget = mobileMenu.querySelector('button, a');
    if (focusTarget) focusTarget.focus();
  };

  const closeMenu = () => {
    if (!mobileMenu || !menuToggle) return;
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    menuToggle.setAttribute('aria-expanded', 'false');
    body.classList.remove('menu-open');
    setScrim(filters?.classList.contains('is-open'));
    if (lastFocused) lastFocused.focus();
  };

  const openFilters = () => {
    if (!filters || !filterToggle) return;
    lastFocused = doc.activeElement;
    filters.classList.add('is-open');
    filters.setAttribute('aria-hidden', 'false');
    filterToggle.setAttribute('aria-expanded', 'true');
    body.classList.add('filters-open');
    setScrim(true);
    filterClose?.focus();
  };

  const closeFilters = () => {
    if (!filters || !filterToggle) return;
    filters.classList.remove('is-open');
    filters.setAttribute('aria-hidden', window.innerWidth <= 900 ? 'true' : 'false');
    filterToggle.setAttribute('aria-expanded', 'false');
    body.classList.remove('filters-open');
    setScrim(mobileMenu?.classList.contains('is-open'));
    if (lastFocused) lastFocused.focus();
  };

  menuToggle?.addEventListener('click', openMenu);
  menuClose?.addEventListener('click', closeMenu);
  filterToggle?.addEventListener('click', openFilters);
  filterClose?.addEventListener('click', closeFilters);
  scrim?.addEventListener('click', () => {
    closeMenu();
    closeFilters();
  });

  doc.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    closeMenu();
    closeFilters();
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth > 900) {
      closeMenu();
      if (filters) filters.setAttribute('aria-hidden', 'false');
    } else if (filters && !filters.classList.contains('is-open')) {
      filters.setAttribute('aria-hidden', 'true');
    }
  });

  if (filters) filters.setAttribute('aria-hidden', window.innerWidth <= 900 ? 'true' : 'false');

  doc.querySelectorAll('[data-sort-select]').forEach((select) => {
    select.addEventListener('change', () => select.form?.submit());
  });

  doc.querySelectorAll('[data-media-target]').forEach((thumbnail) => {
    thumbnail.addEventListener('click', () => {
      const mediaId = thumbnail.dataset.mediaTarget;
      const gallery = thumbnail.closest('[data-product-media]');
      gallery?.querySelectorAll('[data-media-id]').forEach((media) => {
        media.classList.toggle('is-active', media.dataset.mediaId === mediaId);
      });
      gallery?.querySelectorAll('[data-media-target]').forEach((thumb) => {
        thumb.classList.toggle('is-active', thumb === thumbnail);
      });
    });
  });

  doc.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', select.value);
      window.history.replaceState({}, '', url.toString());
    });
  });

  const revealElements = doc.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const revealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -4% 0px' });
    revealElements.forEach((element) => revealObserver.observe(element));
  } else {
    revealElements.forEach((element) => element.classList.add('is-visible'));
  }

  const header = doc.querySelector('[data-site-header]');
  if (header) {
    const updateHeader = () => header.classList.toggle('is-scrolled', window.scrollY > 20);
    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });
  }
})();
